import { KYMW0900Model } from "../kymw0900.model";
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from "src/app/shared/vo/pless-request.model";

/**
 * 取扱生協取得処理サービス
 *
 * @export GetGoodsUseCoopService
 * @class GetGoodsUseCoopService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetGoodsUseCoopService extends PlessJsonResponderSub<any> {

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetGoodsUseCoopService
   */
  private successFunc: Function;

  model: KYMW0900Model;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetGoodsUseCoopService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        PCode: this.model.pCode,
        OrderCode: this.model.orderCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetGoodsUseCoopService
   */
  execute(model: any, successFunc: Function = null): void {
    this.model = model;
    this.successFunc = successFunc;
    this.send('getGoodsUseCoop', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetGoodsUseCoopService
   */
  success(data: any): void {
    if (data !== null) {
      if (this.successFunc) {
        this.successFunc(data);
      }
    }
  }
}
